import { render, staticRenderFns } from "./modal-historico-pontuacao.vue?vue&type=template&id=f4b7d62c&scoped=true"
import script from "./modal-historico-pontuacao.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-pontuacao.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-situacao.scss?vue&type=style&index=0&id=f4b7d62c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b7d62c",
  null
  
)

export default component.exports